import * as React from "react"
import { CircleAlert } from "lucide-react"
import { Badge } from "@shadcn/components/ui/badge"
import { cn } from "@shadcn/lib/utils"

export interface LimitBadgeProps {
	/**
	 * Current usage count
	 */
	used: number
	/**
	 * Maximum limit
	 */
	limit: number
	/**
	 * Label for the resource
	 * @default "users"
	 */
	label?: string
	/**
	 * Additional class name
	 */
	className?: string
}

/**
 * LimitBadge - Displays usage limit with color-coded states for user limits
 */
export function LimitBadge({ used, limit, label = "users", className }: LimitBadgeProps) {
	const isOverLimit = used > limit

	const getStyles = () => {
		if (isOverLimit) {
			return "bg-error-100 text-error-700 border-error-200"
		}
		return "bg-teal-50 text-teal-700 border-teal-200"
	}

	return (
		<Badge variant="outline" className={cn("inline-flex items-center gap-2", getStyles(), className)}>
			{isOverLimit && <CircleAlert className="h-3.5 w-3.5" />}
			<span>
				<span className="font-bold">{used}</span>/{limit} {label}
			</span>
		</Badge>
	)
}
